// extracted by mini-css-extract-plugin
export var grid = "_u-0";
export var span1 = "_u-2";
export var span10 = "_u-b";
export var span10L = "_u-z";
export var span10M = "_u-n";
export var span10Xl = "_u-1b";
export var span11 = "_u-c";
export var span11L = "_u-10";
export var span11M = "_u-o";
export var span11Xl = "_u-1c";
export var span12 = "_u-d";
export var span12L = "_u-11";
export var span12M = "_u-p";
export var span12Xl = "_u-1d";
export var span1L = "_u-q";
export var span1M = "_u-e";
export var span1Xl = "_u-12";
export var span2 = "_u-3";
export var span2L = "_u-r";
export var span2M = "_u-f";
export var span2Xl = "_u-13";
export var span3 = "_u-4";
export var span3L = "_u-s";
export var span3M = "_u-g";
export var span3Xl = "_u-14";
export var span4 = "_u-5";
export var span4L = "_u-t";
export var span4M = "_u-h";
export var span4Xl = "_u-15";
export var span5 = "_u-6";
export var span5L = "_u-u";
export var span5M = "_u-i";
export var span5Xl = "_u-16";
export var span6 = "_u-7";
export var span6L = "_u-v";
export var span6M = "_u-j";
export var span6Xl = "_u-17";
export var span7 = "_u-8";
export var span7L = "_u-w";
export var span7M = "_u-k";
export var span7Xl = "_u-18";
export var span8 = "_u-9";
export var span8L = "_u-x";
export var span8M = "_u-l";
export var span8Xl = "_u-19";
export var span9 = "_u-a";
export var span9L = "_u-y";
export var span9M = "_u-m";
export var span9Xl = "_u-1a";
export var stretch = "_u-1";